export const MortgageReason = {
    MortgageApproval: 755980000,
    FoundHome: 755980001,
    Researching: 755980002,
    ReducePayments: 755980003,
    LockIn: 755980004,
    TopUp: 755980005,
    zerotosixmonths:755980009,
    sixtotwelvemonths:755980010,
    twelveplusmonths:755980011
}
